export default __webpack_public_path__ + "static/hero2-0726fbbacf6a5a6613235b98b1a45257.png";